import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';
import { TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';
const interactionType = {
  expireSoon: TRACKING_INTERACTION.TARGETED_OFFERS.EXPIRES_SOON,
  expireToday: TRACKING_INTERACTION.TARGETED_OFFERS.EXPIRES_TODAY,
  multipleExpires: TRACKING_INTERACTION.TARGETED_OFFERS.MULTIPLE_EXPIRES,
  soldOut: TRACKING_INTERACTION.TARGETED_OFFERS.SOLD_OUT,
};
export const utagBannerLoad = typeBanner => {
  const selectedInteraction = interactionType[typeBanner];
  if (selectedInteraction) {
    const interactionType = {
      eventType: TRACKING_ACTION.INTERACTIONS,
      interaction: selectedInteraction,
    };
    const interaction = createUserInteraction(interactionType);
    trackEvent(interaction);
  }
};
